/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import {
  getUsers,
  listTenants,
  listTenantsUsers,
  tenantsUsersByUsersId,
} from "../graphql/queries";
import { generateClient } from "aws-amplify/api";
import {
  createTenantsUsers,
  deleteTenantsUsers,
  updateUsers,
} from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function UsersUpdateForm(props) {
  const {
    id: idProp,
    users: usersModelProp,
    onSuccess,
    onError,
    onSubmit,
    onCancel,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    id: "",
    username: "",
    firstname: "",
    lastname: "",
    tenants: [],
  };
  const [id, setId] = React.useState(initialValues.id);
  const [username, setUsername] = React.useState(initialValues.username);
  const [firstname, setFirstname] = React.useState(initialValues.firstname);
  const [lastname, setLastname] = React.useState(initialValues.lastname);
  const [tenants, setTenants] = React.useState(initialValues.tenants);
  const [tenantsLoading, setTenantsLoading] = React.useState(false);
  const [tenantsRecords, setTenantsRecords] = React.useState([]);
  const autocompleteLength = 10;
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = usersRecord
      ? { ...initialValues, ...usersRecord, tenants: linkedTenants }
      : initialValues;
    setId(cleanValues.id);
    setUsername(cleanValues.username);
    setFirstname(cleanValues.firstname);
    setLastname(cleanValues.lastname);
    setTenants(cleanValues.tenants ?? []);
    setCurrentTenantsValue(undefined);
    setCurrentTenantsDisplayValue("");
    setErrors({});
  };
  const [usersRecord, setUsersRecord] = React.useState(usersModelProp);
  const [linkedTenants, setLinkedTenants] = React.useState([]);
  const canUnlinkTenants = false;
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getUsers.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getUsers
        : usersModelProp;
      const linkedTenants = record
        ? (
            await client.graphql({
              query: tenantsUsersByUsersId.replaceAll("__typename", ""),
              variables: {
                usersId: record.id,
              },
            })
          ).data.tenantsUsersByUsersId.items.map((t) => t.tenants)
        : [];
      setLinkedTenants(linkedTenants);
      setUsersRecord(record);
    };
    queryData();
  }, [idProp, usersModelProp]);
  React.useEffect(resetStateValues, [usersRecord, linkedTenants]);
  const [currentTenantsDisplayValue, setCurrentTenantsDisplayValue] =
    React.useState("");
  const [currentTenantsValue, setCurrentTenantsValue] =
    React.useState(undefined);
  const tenantsRef = React.createRef();
  const getIDValue = {
    tenants: (r) => JSON.stringify({ id: r?.id }),
  };
  const tenantsIdSet = new Set(
    Array.isArray(tenants)
      ? tenants.map((r) => getIDValue.tenants?.(r))
      : getIDValue.tenants?.(tenants)
  );
  const getDisplayValue = {
    tenants: (r) => `${r?.subdomain ? r?.subdomain + " - " : ""}${r?.id}`,
  };
  const validations = {
    id: [{ type: "Required" }],
    username: [{ type: "Required" }],
    firstname: [],
    lastname: [],
    tenants: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const fetchTenantsRecords = async (value) => {
    setTenantsLoading(true);
    const newOptions = [];
    let newNext = "";
    while (newOptions.length < autocompleteLength && newNext != null) {
      const variables = {
        limit: autocompleteLength * 5,
        filter: {
          or: [{ subdomain: { contains: value } }, { id: { contains: value } }],
        },
      };
      if (newNext) {
        variables["nextToken"] = newNext;
      }
      const result = (
        await client.graphql({
          query: listTenants.replaceAll("__typename", ""),
          variables,
        })
      )?.data?.listTenants?.items;
      var loaded = result.filter(
        (item) => !tenantsIdSet.has(getIDValue.tenants?.(item))
      );
      newOptions.push(...loaded);
      newNext = result.nextToken;
    }
    setTenantsRecords(newOptions.slice(0, autocompleteLength));
    setTenantsLoading(false);
  };
  React.useEffect(() => {
    fetchTenantsRecords("");
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          id,
          username,
          firstname: firstname ?? null,
          lastname: lastname ?? null,
          tenants: tenants ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(
                    fieldName,
                    item,
                    getDisplayValue[fieldName]
                  )
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(
                fieldName,
                modelFields[fieldName],
                getDisplayValue[fieldName]
              )
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const promises = [];
          const tenantsToLinkMap = new Map();
          const tenantsToUnLinkMap = new Map();
          const tenantsMap = new Map();
          const linkedTenantsMap = new Map();
          tenants.forEach((r) => {
            const count = tenantsMap.get(getIDValue.tenants?.(r));
            const newCount = count ? count + 1 : 1;
            tenantsMap.set(getIDValue.tenants?.(r), newCount);
          });
          linkedTenants.forEach((r) => {
            const count = linkedTenantsMap.get(getIDValue.tenants?.(r));
            const newCount = count ? count + 1 : 1;
            linkedTenantsMap.set(getIDValue.tenants?.(r), newCount);
          });
          linkedTenantsMap.forEach((count, id) => {
            const newCount = tenantsMap.get(id);
            if (newCount) {
              const diffCount = count - newCount;
              if (diffCount > 0) {
                tenantsToUnLinkMap.set(id, diffCount);
              }
            } else {
              tenantsToUnLinkMap.set(id, count);
            }
          });
          tenantsMap.forEach((count, id) => {
            const originalCount = linkedTenantsMap.get(id);
            if (originalCount) {
              const diffCount = count - originalCount;
              if (diffCount > 0) {
                tenantsToLinkMap.set(id, diffCount);
              }
            } else {
              tenantsToLinkMap.set(id, count);
            }
          });
          tenantsToUnLinkMap.forEach(async (count, id) => {
            const recordKeys = JSON.parse(id);
            const tenantsUsersRecords = (
              await client.graphql({
                query: listTenantsUsers.replaceAll("__typename", ""),
                variables: {
                  filter: {
                    and: [
                      { tenantsId: { eq: recordKeys.id } },
                      { usersId: { eq: usersRecord.id } },
                    ],
                  },
                },
              })
            )?.data?.listTenantsUsers?.items;
            for (let i = 0; i < count; i++) {
              promises.push(
                client.graphql({
                  query: deleteTenantsUsers.replaceAll("__typename", ""),
                  variables: {
                    input: {
                      id: tenantsUsersRecords[i].id,
                    },
                  },
                })
              );
            }
          });
          tenantsToLinkMap.forEach((count, id) => {
            const tenantsToLink = tenantsRecords.find((r) =>
              Object.entries(JSON.parse(id)).every(
                ([key, value]) => r[key] === value
              )
            );
            for (let i = count; i > 0; i--) {
              promises.push(
                client.graphql({
                  query: createTenantsUsers.replaceAll("__typename", ""),
                  variables: {
                    input: {
                      usersId: usersRecord.id,
                      tenantsId: tenantsToLink.id,
                    },
                  },
                })
              );
            }
          });
          const modelFieldsToSave = {
            id: modelFields.id,
            username: modelFields.username,
            firstname: modelFields.firstname ?? null,
            lastname: modelFields.lastname ?? null,
          };
          promises.push(
            client.graphql({
              query: updateUsers.replaceAll("__typename", ""),
              variables: {
                input: {
                  id: usersRecord.id,
                  ...modelFieldsToSave,
                },
              },
            })
          );
          await Promise.all(promises);
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "UsersUpdateForm")}
      {...rest}
    >
      <TextField
        label="Id"
        isRequired={true}
        isReadOnly={true}
        value={id}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              id: value,
              username,
              firstname,
              lastname,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.id ?? value;
          }
          if (errors.id?.hasError) {
            runValidationTasks("id", value);
          }
          setId(value);
        }}
        onBlur={() => runValidationTasks("id", id)}
        errorMessage={errors.id?.errorMessage}
        hasError={errors.id?.hasError}
        {...getOverrideProps(overrides, "id")}
      ></TextField>
      <TextField
        label="Username"
        isRequired={true}
        isReadOnly={false}
        value={username}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              id,
              username: value,
              firstname,
              lastname,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.username ?? value;
          }
          if (errors.username?.hasError) {
            runValidationTasks("username", value);
          }
          setUsername(value);
        }}
        onBlur={() => runValidationTasks("username", username)}
        errorMessage={errors.username?.errorMessage}
        hasError={errors.username?.hasError}
        {...getOverrideProps(overrides, "username")}
      ></TextField>
      <TextField
        label="Firstname"
        isRequired={false}
        isReadOnly={false}
        value={firstname}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              id,
              username,
              firstname: value,
              lastname,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.firstname ?? value;
          }
          if (errors.firstname?.hasError) {
            runValidationTasks("firstname", value);
          }
          setFirstname(value);
        }}
        onBlur={() => runValidationTasks("firstname", firstname)}
        errorMessage={errors.firstname?.errorMessage}
        hasError={errors.firstname?.hasError}
        {...getOverrideProps(overrides, "firstname")}
      ></TextField>
      <TextField
        label="Lastname"
        isRequired={false}
        isReadOnly={false}
        value={lastname}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              id,
              username,
              firstname,
              lastname: value,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.lastname ?? value;
          }
          if (errors.lastname?.hasError) {
            runValidationTasks("lastname", value);
          }
          setLastname(value);
        }}
        onBlur={() => runValidationTasks("lastname", lastname)}
        errorMessage={errors.lastname?.errorMessage}
        hasError={errors.lastname?.hasError}
        {...getOverrideProps(overrides, "lastname")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              id,
              username,
              firstname,
              lastname,
              tenants: values,
            };
            const result = onChange(modelFields);
            values = result?.tenants ?? values;
          }
          setTenants(values);
          setCurrentTenantsValue(undefined);
          setCurrentTenantsDisplayValue("");
        }}
        currentFieldValue={currentTenantsValue}
        label={"Tenants"}
        items={tenants}
        hasError={errors?.tenants?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("tenants", currentTenantsValue)
        }
        errorMessage={errors?.tenants?.errorMessage}
        getBadgeText={getDisplayValue.tenants}
        setFieldValue={(model) => {
          setCurrentTenantsDisplayValue(
            model ? getDisplayValue.tenants(model) : ""
          );
          setCurrentTenantsValue(model);
        }}
        inputFieldRef={tenantsRef}
        defaultFieldValue={""}
      >
        <Autocomplete
          label="Tenants"
          isRequired={false}
          isReadOnly={false}
          placeholder="Search Tenants"
          value={currentTenantsDisplayValue}
          options={tenantsRecords.map((r) => ({
            id: getIDValue.tenants?.(r),
            label: getDisplayValue.tenants?.(r),
          }))}
          isLoading={tenantsLoading}
          onSelect={({ id, label }) => {
            setCurrentTenantsValue(
              tenantsRecords.find((r) =>
                Object.entries(JSON.parse(id)).every(
                  ([key, value]) => r[key] === value
                )
              )
            );
            setCurrentTenantsDisplayValue(label);
            runValidationTasks("tenants", label);
          }}
          onClear={() => {
            setCurrentTenantsDisplayValue("");
          }}
          onChange={(e) => {
            let { value } = e.target;
            fetchTenantsRecords(value);
            if (errors.tenants?.hasError) {
              runValidationTasks("tenants", value);
            }
            setCurrentTenantsDisplayValue(value);
            setCurrentTenantsValue(undefined);
          }}
          onBlur={() =>
            runValidationTasks("tenants", currentTenantsDisplayValue)
          }
          errorMessage={errors.tenants?.errorMessage}
          hasError={errors.tenants?.hasError}
          ref={tenantsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "tenants")}
        ></Autocomplete>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || usersModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Go Back"
            type="button"
            onClick={() => {
              onCancel && onCancel();
            }}
            {...getOverrideProps(overrides, "CancelButton")}
          ></Button>
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || usersModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
